import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { Result, Spin } from 'antd';
import { getAxiosClient } from '../actions/client'; 
import queryString from "query-string"
import { Trans } from 'react-i18next';


import ARPrimaryButton from '../react/shared/components/general/ARButtons/ARPrimaryButton';
import './SmsPage.css';

class SmsPage extends Component {  
    constructor(props) {
        super(props);
        var { i18n } = props;
        if(props.match && props.match.params && props.match.params.language) {
            i18n.changeLanguage(props.match.params.language);
        }
        const queryParams = queryString.parse(window.location.search);
        const { master_task_id, phone_number } = queryParams;
        const unsubscribed_key = "unsubscribed-"+master_task_id+"-"+phone_number
        this.state = {
            loading: false,
            onError: false,
            master_task_id: master_task_id,
            phone_number: phone_number,
            unsubscribed_key: unsubscribed_key,
            unsubscribed: localStorage.getItem(unsubscribed_key),
        }
    }

    unSubscribeAction = () => {
        const { master_task_id, phone_number } = this.state;
        let { unsubscribed_key } = this.state;

        this.setState({loading: true});

        getAxiosClient(process.env.REACT_APP_API_PORTAL_URL).post('unsubscribe/SMS',{
            "masterTaskID": master_task_id,
            "data": phone_number
        })
        .then( results => {
            console.log(results)
            localStorage.setItem(unsubscribed_key, true);
            this.setState({
                unsubscribed: true,
                loading: false
            });
        })
        .catch(err => {
            this.setState({onError: true});
        }) 
    }


    render() {
        var { t } = this.props;
        const { unsubscribed, onError, loading, phone_number} = this.state;
        const PNF = require('google-libphonenumber').PhoneNumberFormat;
        const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

        let format_number = 'CA';
        if (this.props.match && this.props.match.params && this.props.match.params.language.toLowerCase()==="fr"){
            format_number = this.props.match.params.language;
        }

        let imgProps = {
            src:'/images/img-subscribe.png',
            srcSet: '/images/img-subscribe@2x.png 2x,/images/img-subscribe@3x.png 3x'
        };

        if (onError){
            return (
                <Result
                    status="error"
                    title="Error trying to unsubscribe"
                />
            )
        }

        if (unsubscribed){
            imgProps = {
                src:'/images/img-unsubscribe.png',
                srcSet: '/images/img-unsubscribe@2x.png 2x,/images/img-unsubscribe@3x.png 3x'
            };
        }

        const number = phoneUtil.parseAndKeepRawInput(phone_number, format_number);
        const number_formated = phoneUtil.format(number, PNF.NATIONAL);

        return (
            <Spin tip="Loading..." spinning={loading}>
                <div className='sms-page-wrapper'>
                    <div className='unsubscribe-title'>
                        { unsubscribed ? t('We’re sad to see you go…') : t('Unsubscribe')} 
                    </div>
                    <hr/>
                    <div className='unsubscribe-img'> 
                        <img alt="Subscription" {...imgProps} />
                    </div>
                    <div className='unsubscribe-details'>
                        { unsubscribed ?
                            <Trans i18nKey="unsubcribedDescription">
                                You have removed the number below from our contact list:<strong>{{number_formated}}</strong>.
                            </Trans>
                        :
                            <Trans i18nKey="unsubcribeDescription">
                                If you are no longer interested in receiving SMS communication to the number <strong>{{number_formated}}</strong> please click on the Unsubscribe button below.
                            </Trans>
                        }
                    </div>
                    { unsubscribed ? 
                        <></>
                    :
                        <ARPrimaryButton onClick={this.unSubscribeAction} className="unsubscribe-btn">
                            {t('Unsubscribe')}
                        </ARPrimaryButton>
                    }
                </div>
            </Spin>
        )
    }
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps,{})(withTranslation()(SmsPage));